$.fn.conditionallyRevealChosen = function () {
  this.each(function () {
    var $self = $(this);
    var conditionObject = $self.data("condition");

    if (structuredCorrectly(conditionObject)) {
      var conditionName = conditionObject.id;
      var conditionValues = conditionObject.value.toLowerCase().split(",");
      var conditionAction = conditionObject.action
        ? conditionObject.action.toLowerCase()
        : "show";
      var conditionDefaultVal = $("#" + conditionName).val();

      if (conditionDefaultVal != "" || conditionDefaultVal != "undefined") {
        var isCondition = conditionMet(conditionDefaultVal);
        if (isCondition) {
          if (conditionAction === "show") {
            show($self);
          } else {
            hide($self);
          }
        } else {
          if (conditionAction === "show") {
            hide($self);
          } else {
            show($self);
          }
        }
      }

      $("#" + conditionName).on("change", function (e) {
        var isCondition = conditionMet(this.value);

        if (isCondition) {
          if (conditionAction === "show") {
            show($self);
          } else {
            hide($self);
          }
        } else {
          if (conditionAction === "show") {
            hide($self);
          } else {
            show($self);
          }
        }
      });

      function hide(elem) {
        $(elem).attr("disabled", "disabled");
        $(elem).parent(".form-group").attr("hidden", "hidden");
        $(elem).trigger("chosen:updated");
      }

      function show(elem) {
        $(elem).removeAttr("disabled");
        $(elem).parent(".form-group").removeAttr("hidden");
        $(elem).trigger("chosen:updated");
      }

      function conditionMet(choice) {
        var isMet = false;

        if ($.isArray(conditionValues)) {
          $.each(conditionValues, function (i, conditionValue) {
            if (choice.toLowerCase() === conditionValue) {
              isMet = true;

              return false; // Stop looping
            }
          });
        }

        return isMet;
      }
    }

    function structuredCorrectly(obj) {
      return (
        obj.hasOwnProperty("id") &&
        obj.hasOwnProperty("value") &&
        obj.hasOwnProperty("action")
      );
    }
  });
};
